export const FALLOFFS_BY_RECRUITER_COLUMNS = [
  {
    name: 'empNo',
    options: {
      display: 'excluded'
    }
  },
  {
    name: 'recruiterName',
    label: 'Recruiter / Transaction',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'managerName',
    label: 'Team',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      display: true,
      sort: true
    }
  },
  {
    name: 'total',
    label: 'Amount',
    options: {
      display: true,
      sort: true,
      renderer: 'currency'
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'recruiterName',
  direction: 'asc'
};
